import { Classes } from "@blueprintjs/core";

import { SpecialtyNeededOption } from "@/components/pages_flexible/match/SpecialtyOptionNeeded";
import { ComponentTypeEnum, useBasicSpecialtiesQuery } from "@/graphql";
import { cn } from "@/lib/utils";
import { BasicSpecialty } from "@/types/products";
import { ComponentTabProps } from "@/types/programs";
import { ensureNonNullArray } from "@/utils/array";

export interface ProgramComponentCreationType {
  id: number;
  name: string;
  icon: string;
  value: ComponentTypeEnum;
  description: string;
  active: boolean;
  group: string;
}

export function ChooseSpecialty({
  onNext,
  programComponent,
}: ComponentTabProps) {
  const { data, loading } = useBasicSpecialtiesQuery();
  const selectedSpecialty = programComponent?.specialty;

  const onSelectComponentType = (specialty: BasicSpecialty) => {
    onNext({
      value: {
        specialty: specialty.id,
      },
      isNext: true,
      isSave: true,
    });
  };

  const specialties = ensureNonNullArray(data?.specialties);

  return (
    <div className="flex flex-col gap-6 max-w-148 my-0 mx-auto p-9">
      <div className="text-2xl font-semibold">What type of coaching?</div>
      {loading
        ? [1, 2, 3, 4].map((i) => (
            <div key={i} className={cn(Classes.SKELETON, "h-25")} />
          ))
        : specialties
            .filter((specialty) => !specialty.hiddenInMatchFlow)
            .map((specialty) => (
              <div key={specialty.slug}>
                <SpecialtyNeededOption
                  specialty={specialty}
                  onClick={() => onSelectComponentType(specialty)}
                  elevation={2}
                  className={
                    selectedSpecialty?.id === specialty.id ? "active" : ""
                  }
                />
              </div>
            ))}
    </div>
  );
}
